import BigNumber from 'bignumber.js'
import { convertSharesToXp } from 'views/Pools/helpers'
import { multicallv2 } from 'utils/multicall'
import igoPoolAbi from 'config/abi/igoPool.json'
import { getIgoPoolAddress } from 'utils/addressHelpers'
import { BIG_ZERO } from 'utils/bigNumber'

export const fetchPublicIgoPoolData = async () => {
  try {
    const calls = [
      'getPricePerFullShare',
      'totalShares',
      'calculateHarvestXpRewards',
      'calculateTotalPendingXpRewards',
      'startBlock',
      'endBlock',
    ].map((method) => ({
      address: getIgoPoolAddress(),
      name: method,
    }))

    const [[sharePrice], [shares], [estimatedXpBountyReward], [totalPendingXpHarvest], [startBlock], [endBlock]] =
      await multicallv2(igoPoolAbi, calls)

    const totalSharesAsBigNumber = shares ? new BigNumber(shares.toString()) : BIG_ZERO
    const sharePriceAsBigNumber = sharePrice ? new BigNumber(sharePrice.toString()) : BIG_ZERO
    const totalXpInVaultEstimate = convertSharesToXp(totalSharesAsBigNumber, sharePriceAsBigNumber)
    return {
      totalShares: totalSharesAsBigNumber.toJSON(),
      pricePerFullShare: sharePriceAsBigNumber.toJSON(),
      totalXpInVault: totalXpInVaultEstimate.xpAsBigNumber.toJSON(),
      estimatedXpBountyReward: new BigNumber(estimatedXpBountyReward.toString()).toJSON(),
      totalPendingXpHarvest: new BigNumber(totalPendingXpHarvest.toString()).toJSON(),
      creditStartBlock: startBlock.toNumber(),
      creditEndBlock: endBlock.toNumber(),
    }
  } catch (error) {
    return {
      totalShares: null,
      pricePerFullShare: null,
      totalXpInVault: null,
      estimatedXpBountyReward: null,
      totalPendingXpHarvest: null,
    }
  }
}

export const fetchIgoPoolFeesData = async () => {
  try {
    const calls = ['performanceFee', 'callFee', 'withdrawFee', 'withdrawFeePeriod'].map((method) => ({
      address: getIgoPoolAddress(),
      name: method,
    }))

    const [[performanceFee], [callFee], [withdrawalFee], [withdrawalFeePeriod]] = await multicallv2(igoPoolAbi, calls)

    return {
      performanceFee: performanceFee.toNumber(),
      callFee: callFee.toNumber(),
      withdrawalFee: withdrawalFee.toNumber(),
      withdrawalFeePeriod: withdrawalFeePeriod.toNumber(),
    }
  } catch (error) {
    return {
      performanceFee: null,
      callFee: null,
      withdrawalFee: null,
      withdrawalFeePeriod: null,
    }
  }
}

export default fetchPublicIgoPoolData
